import React, { Component } from 'react';
import { ACTIVE_PROFILE } from '../../config';

// Components
import {
  Container,
  Row,
  Col
} from 'reactstrap';
import {ResponsiveImage} from 'dabbl-react-components';
import Jumbotron from './components/Jumbotron';

// Data
import waysToSaveData from '../data/waysToSave';

const WaysToSaveBar = () => {
  return (
    <Container className="HomePage_bar">
      <Row className="HomePage_bar_header">
        <Col xs={12}>
          <h1 className="text-center">One. Two. Save.</h1>
        </Col>
      </Row>

      <Row>
        {/* Use custom card stylings to prevent border */}
        {waysToSaveData.map((d,i) => (
          <Col xs={12} sm={4} key={i}>
            <ResponsiveImage
              src={d.imgUrl}
              alt={d.text}
              aspectRatio="1:1"
            />

            <h6 className="HomePage_card_title">{d.title}</h6>
            <p className="HomePage_card_text">{d.text}</p>
            {d.subtext && (
              <p className="HomePage_card_text">{d.subtext}</p>
            )}
          </Col>
        ))}
      </Row>
    </Container>
  );
}

class HomePage extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    const { isAuthenticated, history, location, createNewUserOrSignIn, setLoading } = this.props;
    const params = new URLSearchParams(location.search);
    const account_id = params.get('account_id');
    const user_id = params.get('user_id');

    if (account_id) {
      localStorage.setItem('account_id', account_id);
    }
    if (user_id) {
      localStorage.setItem('user_id', user_id);
    }
    console.log('Account ID from query:', account_id);
    console.log('User ID from query:', user_id);
    if (isAuthenticated) {
      history.push('/app/campaigns');
      return
    }
    if (!account_id || !user_id) {
      console.error('Failed to authenticate user.');
      history.push('/app/noloyaltycard');
    }

    if (user_id) {
      setLoading(true);
      createNewUserOrSignIn(user_id, account_id)
        .then((isNewUser) => { // redirect
          history.push('/app/campaigns');
        })
        .catch(err => {
          this.setState({ isLoading: false });

          console.error('Failed to authenticate user.');
          console.error(err);
          // history.push('/login');
        });
    } else {
      // fallback if no user_id in query
      if (!isAuthenticated) {
        history.push('/app/noloyaltycard');
      } else {
        // if (seenTutorial)
        history.push('/app/campaigns');
        // else history.push('/app/tutorial');
      }
    }

  }

  handleGetStartedClick() {
    const {
      isAuthenticated,
      seenTutorial,
      history,
      location,
      createNewUserOrSignIn
    } = this.props;

    console.log(location);
    // Parse account_id from query parameters


    const params = new URLSearchParams(location.search);
    const account_id = params.get('account_id');
    const user_id = params.get('user_id');

    if (user_id) {
      createNewUserOrSignIn(user_id, account_id)
        .then((isNewUser) => { // redirect
          if (isNewUser !== true)
            history.push('/app/campaigns');
          else history.push('/app/tutorial');
        })
        .catch(err => {
          this.setState({ isLoading: false });

          console.error('Failed to authenticate user.');
          console.error(err);
         // history.push('/login');
        });
    } else {
      console.log("testtststs")
      // fallback if no user_id in query
      if (!isAuthenticated) {
        history.push('/app/noloyaltycard');
      } else {
        // if (seenTutorial)
        history.push('/app/campaigns');
        // else history.push('/app/tutorial');
      }
    }
  }

  render() {
    return (
      <div className="HomePage">
        <Jumbotron onBtnClick={() => this.handleGetStartedClick()} />
        <WaysToSaveBar />
      </div>
    );
  }

}

export default HomePage;



// WEBPACK FOOTER //
// ./src/pages/Home/Home.js